import { isTabletPortraitDown } from '@enter/core';
import { mdiArrowLeft } from '@mdi/js';
import { Icon } from '@mdi/react';
import { ContactSupport } from 'components';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { ISettingsPage } from '../shared';
import * as S from '../shared.styles';

export const Email: React.FunctionComponent = inject('rootStore')(
    observer(
        (props: ISettingsPage): React.ReactElement => {
            const email = _.get(props, 'rootStore.userEmail', '');
            return (
                <S.SubCategoryItem>
                    {isTabletPortraitDown() && (
                        <S.ReturnLink to="/settings/overview">
                            {(): React.ReactElement => <Icon path={mdiArrowLeft} size={1} />}
                        </S.ReturnLink>
                    )}
                    <S.SubCategoryH1>What is your email address?</S.SubCategoryH1>
                    <S.InputGroup>
                        <S.Label>Email</S.Label>
                        <S.Input value={email} disabled={true} />
                    </S.InputGroup>
                    <ContactSupport action="change your email address" subject="Need help changing email address" />
                </S.SubCategoryItem>
            );
        },
    ),
);
